import personalPropertyGraphic from "@/shared/assets/illustrations/personal-property-chest.svg";

import type { FlowScreenConfig } from "@/shared/constants/flowTypes";

import { VehiclesReview } from "../components/VehiclesReview";
import { AddVehicle } from "../components/AddVehicle";
import { AutoLoanForm } from "../components/AutoLoanForm";
import { VehicleEstimator } from "../components/VehicleEstimator";

export function createVehiclesScreens(firstName: string): FlowScreenConfig[] {
  return [
    {
      id: "personal_property_intro",
      layout: "full",
      imageSrc: personalPropertyGraphic,
      imageSize: "md",
      imagePosition: "right",
      verticalCenter: true,
      sectionLabel: "Section 4",
      maxWidth: "4xl",
      title: `Let's identify ${firstName}'s tangible personal property`,
      subtitle: `We'll go through ${firstName}'s vehicles, valuables, and personal belongings, one piece at a time. This helps us account for what they owned, keep it safe, and pass each piece to the right people.`,
      getButtonText: () => "Get started",
    },
    {
      id: "has_vehicle",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      title: `Did ${firstName} own any vehicles?`,
      subtitle: "This includes cars, motorcycles, boats, RVs, or other vehicles.",
      question: {
        type: "multiple_choice",
        required: true,
        options: [
          { value: "yes", label: "Yes, they had vehicles" },
          { value: "no", label: "No vehicles" },
          { value: "not_sure", label: "Not sure" },
        ],
      },
      shouldDisplay: ({ answers }) => !answers["add_vehicle"] || answers["add_vehicle"] !== "done",
    },
    {
      id: "add_vehicle",
      layout: "full",
      textAlign: "center",
      maxWidth: "4xl",
      title: `Add ${firstName}'s vehicle`,
      subtitle: "Enter the details you have. We'll estimate the value for you.",
      hideButton: true,
      skipOnBack: true,
      customComponent: AddVehicle,
      shouldDisplay: ({ answers }) =>
        answers["has_vehicle"] === "yes" && answers["add_vehicle"] !== "done",
    },
    {
      id: "add_auto_loan",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      title: "Tell us about the auto loan",
      subtitle: "Add what you know. You can come back to fill in more anytime.",
      hideButton: true,
      customComponent: AutoLoanForm,
      shouldDisplay: ({ answers }) =>
        answers["has_auto_loan"] === "yes" && answers["auto_loan_done"] !== "yes",
    },
    {
      id: "vehicle_estimate",
      layout: "full",
      hideButton: true,
      customComponent: VehicleEstimator,
      shouldDisplay: ({ answers }) =>
        answers["add_vehicle"] === "done" && answers["vehicle_estimate_done"] !== "yes",
    },
    {
      id: "vehicles_review_step",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      hideButton: true,
      customComponent: VehiclesReview,
      shouldDisplay: ({ answers }) => answers["vehicle_estimate_done"] === "yes",
    },
    {
      id: "add_another_vehicle",
      layout: "full",
      textAlign: "center",
      maxWidth: "4xl",
      title: `Add ${firstName}'s vehicle`,
      subtitle: "Enter the details you have. We'll estimate the value for you.",
      hideButton: true,
      customComponent: AddVehicle,
      shouldDisplay: ({ answers }) => answers["_add_from_review"] === "vehicles",
    },
  ];
}
